<!--
<style lang="less">
  @import './login.less';
</style>
-->
<template>
  <div
    class="login"
    :style="{
      background: 'url(' + loginBgImg + ') no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
    }"
  >
    <div class="name" v-if="false">
      <!-- <strong>美孚OCM油液监测系统</strong> -->
      <img src="@/assets/images/menu-logo.png" alt="美孚OCM油液监测系统" />
    </div>
    <div class="login-con">
      <lognleft />
      <Card
        class="conf-right"
        :title="wxLogin ? null : '账号验证'"
        :bordered="false"
        dis-hover
      >
        <div class="form-con" v-if="wxLogin">
          <weixin-form ref="loginForm"></weixin-form>
        </div>
        <div class="form-con" v-else-if="valid">
          <phonevali-form
            @on-success-valid="handleSubmit"
            ref="loginForm"
            :unionid="unionid"
          />
        </div>
        <div class="form-con" v-else-if="validPhone">
          <phone-form
            @on-success-valid="handleSubmit"
            :validPhone="validPhone"
            :role="role"
            :unionid="unionid"
            :btnLoading="btnLoading"
            :isLoadingFunc="isLoadingFunc"
            ref="loginForm"
          />
        </div>

        <!-- ========= Test ========= -->
        <div
          v-if="wxLogin && isDev"
          style="text-align: center; position: relative; top: -15px"
        >
          <div v-show="false">
            {{ wxLogin }},{{ isDev }} {{ valid }} {{ validPhone }}
          </div>
          <Button
            class="cbtn"
            :loading="ltest"
            id="m0btn"
            type="primary"
            v-show="!isStg"
            @click="verification('m')"
            >美孚管理员</Button
          >
          &nbsp;&nbsp;
          <Button  id="a0btn" :loading="ltest" type="primary" @click="verification('a')"
            >经销商管理员</Button
          >
          &nbsp;&nbsp;
          <Button
            class="cbtn"
            :loading="ltest"
            type="primary"
            @click="verification('c')"
            id="c0btn"
            >客户管理员</Button
          >
          <div style="margin-top: 10px">
            <Button
              class="cbtn"
              :loading="ltest"
              type="primary"
              id="m1btn"
              @click="verification('muser')"
              >美孚普通用户</Button
            >
            &nbsp;&nbsp;
            <Button
              class="cbtn"
              :loading="ltest"
              type="primary"
              id="a1btn"
              @click="verification('auser')"
              >经销商普通用户</Button
            >

            &nbsp;&nbsp;
            <Button
              class="cbtn"
              :loading="ltest"
               id="c1btn"
              type="primary"
              @click="verification('cuser')"
            >
              客户普通用户</Button
            >
          </div>
        </div>
      </Card>
    </div>
    <Modal class="newModal" v-model="modal1" title="请输入密码" @on-ok="ok">
      <Input
        style="margin-bottom: 24px"
        :autofocus="true"
        ref="atlas-name-input"
        v-model="pwdvalue"
        name="pawword"
        type="password"
        @keyup.enter.native="ok"
        placeholder="请输入密码"
      />
      <div class="drawer-footer" slot="footer">
        <Button type="primary" id="login-submit" @click="ok('formValidate')" :loading="btnLoading"
          >提交</Button
        >
        <Button style="margin-left: 8px" @click="modal1 = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import phonevaliForm from "@/components/login-form/phonevali-form.vue";
import phoneForm from "@/components/login-form/phone-form.vue";
import weixinForm from "@/components/login-form/weixin-form.vue";
import lognleft from "@/components/login-form/logn-left.vue";
import { loginifo } from "@/api/pubrequst.js";
import { getCurToken, setUserInfo } from "@/util/index";
import CryptoJS from "crypto-js";

export default {
  components: {
    phonevaliForm,
    phoneForm,
    weixinForm,
    lognleft,
  },
  // https://stg.nonprd-ocm.mobil.com.cn/customer/login
  data() {
    return {
      unionid: null,
      loginBgImg: require("@/assets/images/login-bg.png"),
      wxLogin: true,
      valid: false,
      validPhone: null,
      role: null,
      ltest: false,
      btnLoading: false,
      azureLoading: false,
      modal1: false,
      isDev:
        process.env.NODE_ENV === "development" ||
        window.location.origin.indexOf("ocm.cloudgrow.cn") > -1 ||
        window.location.origin.indexOf("uat.nonprd-ocm.mobil.com.cn") > -1 ||
        window.location.origin.indexOf("stg.nonprd-ocm.mobil.com.cn") > -1,
      isStg: window.location.origin.indexOf("stg.nonprd-ocm.mobil.com.cn") > -1,
      testend: "",
      pwd: "",
      pwdvalue: "",
    };
  },

  created() {
    //  this.$router.push("/index")
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      const token = getCurToken();

      if (token) {
        this.$router.push("/index");
      }
      this.getParams();
    },
    ok() {
      this.btnLoading = true;
      this.loginTest(this.testend);
      // if (pwdvalue == pwd) {    } else {
      //     this.$Message["error"]({
      //       background: true,
      //       content: "请输入正确密码",
      //     });
      //     return;
      //   }
    },
    verification(msg) {
      this.pwdvalue = "";
      this.testend = msg;
      this.modal1 = true;
      this.$nextTick(() => {
        //自动获取焦点
        this.$refs["atlas-name-input"].focus();
      });
    },
    getParams() {
      const urlQuery = this.$router.history.current;
      this.wxLogin = +urlQuery.query.wxlog === 0 ? false : true; // 微信登录
      this.valid = +urlQuery.query.valid === 1 ? true : false; // 验证手机
      this.role = urlQuery.query.role;
      this.validPhone = urlQuery.query.phone;
      this.unionid = urlQuery.query.uid;
    },
    getUserInfo(token) {
      api.axsUserInfo("get", "/ocm-admin/user/me", token).then((res) => {

        // res.data.authority="mobil_user_safety_auditor"
        if (res.code === "00000") {
          let userInfo = {
            ...token,
            ...res.data,
          };
          setUserInfo(userInfo)
          this.$router.push("/index");
          this.$Message.success("登录成功");
          this.$nextTick(() => {
            setTimeout(() => {
              loginifo(1);
            }, 300);
          });
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
          this.btnLoading = false;
        }
      });
    },
    loginTest(type) {
      // 开发阶段 默认账号密码登录 TODO
      this.ltest = true;
      let usename = "";
      if (type === "m") {
        usename = "admin";
      } else if (type == "c") {
        usename = "cadmin";
      } else if (type == "a") {
        usename = "aadmin";
      } else {
        usename = type;
      }
      const password = CryptoJS.SHA256(this.pwdvalue).toString(CryptoJS.enc.Hex);
      const datas = {
        grant_type: "password",
        //username: type === 'm' ? 'admin' : type === 'c' ? 'cadmin' : 'aadmin',
        username: usename,
        password,
      };

      api
        .axsl(
          "post",
          "/ocm-auth/oauth/token",
          { grant_type: "password" },
          datas
        )
        .then((res) => {
      
          if (res.code === "00000") {
            this.getUserInfo(res.data);
          }else{
          
          }
          this.ltest = false;
        });
    },

    // 提交手机验证
    handleSubmit(form) {
      let parms = {
        grant_type: "wechat-web",
        unionid: this.unionid,
        identity: form.identity,
      };
      let datas = {};
      if (form.identity === "admin") {
        parms.email = form.email;
        parms.emailCode = form.code;
      } else {
        parms.phone = form.phoneNumber;
        datas.phoneCode = form.code;
      }

      api
        .axsl("post", "/ocm-auth/oauth/token", parms, datas)
        .then((res) => {
          if (res.code === "00000") {
            this.getUserInfo(res.data);
          
          } else {
            this.$Message.error(res.msg);
          }
          this.isLoadingFunc(false);
        })
        .catch((err) => {
          this.isLoadingFunc(false);
        });
    },
    isLoadingFunc(flag) {
      this.btnLoading = flag;
    },
  },
  watch: {
    $route(to, from) {
      this.getParams();
    },
  },
};
</script>

<style lang='less' scoped>
.login {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-color: #3766ad;
  background-position: center;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;

  &-con {
    // position: absolute;
    // right: 160px;
    // left: 50%;
    // margin-left: -445px;
    // top: 51%;
    // transform: translateY(-60%);

    // margin-top: 40px;
    display: flex;
    transform: scale(0.9);

    .con-left {
      width: 475px;
      height: 520px;
      background: linear-gradient(135deg, #0045a3 0%, #00439e 100%);
      border-radius: 0px 0px 0px 40px;
      opacity: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }

    .left-font {
      font-size: 12px;

      font-weight: 500;
      color: #ffffff;
      line-height: 0px;
      position: absolute;
      bottom: 67px;
    }

    .conf-right {
      width: 475px;
      height: 520px;
      background: #ffffff;
      box-shadow: 0px 20px 40px 1px rgba(0, 77, 163, 0.12156862745098039);
      border-radius: 0px 40px 0px 0px;
      opacity: 1;
      overflow: hidden;
    }

    &-header {
      font-size: 16px;
      font-weight: 300;
      text-align: center;
      padding: 30px 0;
    }

    .form-con {
      padding: 10px 0 0;
    }

    .login-tip {
      font-size: 10px;
      text-align: center;
      color: #c3c3c3;
    }
  }

  .name {
    // position: absolute;
    // left: 50%;
    // margin-left: -150px;
    font-size: 20px;
    color: #fff;
    text-align: left;
    padding: 10px 30px 10px 30px;
    background: #0c479d;

    img {
      width: 184px;
      margin-top: 10px;
      background-repeat: no-repeat;
    }
  }
}

.cbtn {
  width: 120px;
}

.ivu-checkbox-inner {
  position: relative;
  left: 3px;
}
</style>
